<section>
    <div class="plan-switch-promotions" *ngIf="resultPage">
        <xm-media-image [imageOptions]="alertIcon" class="icon"></xm-media-image>
        <cms-text class="description" [originalText]="promotionContent"></cms-text>
    </div>
    <div class="plan-switch-multiple-promotions" *ngIf="!resultPage && isBogoPromoLossForUnl">
        <div class="generic-content">
            <xm-media-image [imageOptions]="alertIcon" class="icon"></xm-media-image>
            <cms-text [originalText]="promotionContent"></cms-text>
        </div> 
        <div class="promo-content">
            <ul>
                <li *ngIf="UNLPromoContent">{{UNLPromoContent}}</li>
                <li *ngIf="BYOPromoContent">{{BYOPromoContent}}</li>
                <li *ngIf="extendedPromoContent">{{extendedPromoContent}}</li>
                <li *ngIf="tradeInDDAPromoContent">{{tradeInDDAPromoContent}}</li>
            </ul>  
        </div>
    </div>
    <div class="plan-switch-multiple-promotions" *ngIf="!resultPage && (tradeInDDAPromoContent || extendedPromoContent) && !isBogoPromoLossForUnl">
        <div class="generic-content">
            <xm-media-image [imageOptions]="alertIcon" class="icon"></xm-media-image>
            <cms-text [originalText]="promotionContent"></cms-text>
        </div> 
        <div class="promo-content">
            <ul>
                <li *ngIf="extendedPromoContent">{{extendedPromoContent}}</li>
                <li *ngIf="tradeInDDAPromoContent">{{tradeInDDAPromoContent}}</li>
            </ul>  
        </div>
    </div>
</section>
